import React from "react";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player";

var bgimg1 = require("../../images/background/image3.jfif");

class About3 extends React.Component {
  render() {
    return (
      <>
        <div
          className={`${this.props.bgcolor} organisations section-full mobile-page-padding p-t80 p-b50`}
        >
          {/* <div className="hilite-title text-left p-l50 text-uppercase">
            <strong>Organisation</strong>
          </div> */}
          <div className="container">
            <div className="section-content">
              <div className="row">
                <div
                  data-aos-duration="800"  data-aos="fade-right"
                  className="col-xl-6 col-lg-6 col-md-12"
                >
                  <div className="about-home-3 m-b30 bg-white">
                    <h3 className="m-t0 m-b20 sx-tilte">Organisation :</h3>
                    <p>
                      Conformément au statut de l’association LA VALLEE, ses
                      membres, tous bénévoles, se réunissent en conseil, en
                      bureau et en commissions pour garantir la pertinence de la
                      stratégie de l’association, en cohérence avec son objectif
                      social.
                    </p>
                    <p>
                      <b>Membres du Bureau :</b>
                    </p>
                    <ul className="list-angle-right anchor-line">
                      <li>
                        <NavLink to="/about">
                          Président : M. Khalil LAKBAKBI
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/about">
                          Secrétaire Général : M. Abdelaziz EL MAMOUNI
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/about">
                          Trésorier : M. Abdessamad CHARIFI
                        </NavLink>
                      </li>
                    </ul>
                    {/* <div className="text-left">
                      <NavLink to="/about" className="site-button btn-half">
                        <span>Read More</span>
                      </NavLink>
                    </div> */}
                  </div>
                </div>
                <div
                  data-aos-duration="800"  data-aos="fade-left"
                  className="col-xl-6 col-lg-6 col-md-12"
                >
                  <div className="video-section-full-v2">
                    <div
                      className="video-section-full bg-no-repeat bg-cover bg-center m-b30"
                      style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                    >
                      <div className="overlay-main" />
                      <div className="video-section-inner">
                        <div className="video-section-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default About3;
